import { render, staticRenderFns } from "./studentInfoCertificationRecord_6.vue?vue&type=template&id=4a2764a6&scoped=true"
import script from "./studentInfoCertificationRecord_6.vue?vue&type=script&lang=js"
export * from "./studentInfoCertificationRecord_6.vue?vue&type=script&lang=js"
import style0 from "./studentInfoCertificationRecord_6.vue?vue&type=style&index=0&id=4a2764a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2764a6",
  null
  
)

export default component.exports